var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ClientInfo',{staticClass:"mb-5",attrs:{"currentTab":"branch","typeSection":_vm.typeSection,"name":_vm.name,"companyName":_vm.companyName,"logo":_vm.logo}}),_c('BranchInfo',{attrs:{"currentTab":"branch"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }